export function validateMaxLength(maxLength: number, message: string) {
	return {
		maxLength: {
			value: maxLength,
			message,
		},
	};
}
